<template>
  <div class="service-type-field">
    <p class="custom-input-label">{{ $props.label }}</p>
    <div class="data-wrapper">
      <i :class="getIcon($props.categoryData)"></i>
      <span>{{ `${$props.categoryData.subscriptionInfo ? $props.categoryData.subscriptionInfo.title : ''} - ${$props.categoryData.subscriptionInfo ? $props.categoryData.subscriptionInfo.description : ''}` }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'category-type-field',
  props: {
    categoryData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    label: String
  },
  methods: {
    getIcon (catData) {
      const type = catData.subscriptionInfo ? catData.subscriptionInfo.type : ''
      switch (type) {
        case 'TELEVISION':
          return 'icon-sc-tv'
        case 'INTERNET':
          return 'icon-sc-internet'
        case 'FIXED_TELEPHONY':
          return 'icon-sc-landline'
        case 'MOBILE_PREPAID':
          return 'icon-sc-mobile'
        default:
          return 'icon-sc-mobile'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.service-type-field {
  margin-bottom: 1.6rem;

  .data-wrapper {
    border-radius: 5px;
    background-color: $white;
    padding: 1.2rem 2rem;
    color: $dark-grey;
    display: flex;
    align-items: center;

    i {
      font-size: 2.4rem;
      margin-right: 1.6rem;
    }
  }
}
</style>
